import React from "react";

export default function SQLServer_SUBSTRING() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SUBSTRING</h1>
      <p>This is the SQLServer_SUBSTRING component generated from the SQL JSON.</p>
    </div>
  );
}
